<template>
    <div id="root"
      :style="getFontSize"
    >    
        <common-component
          :redirectLocation="{ path: '/sessionExpired' }"
        />
        <div :class="cssClasses"
        >
            <router-view name="layout"
                         :title="title"
                         :is-x-small="screen.isXSmall"
                         :is-large="screen.isLarge"
                         >
                <div class="content">
                    <router-view name="content" />
                </div>
                <template #footer>
                    <the-footer />
                </template>
            </router-view>
        </div>
    </div>
</template>

<script>
import { TheFooter } from "@questelservices/common-vue";
import { MediaQueryService } from "@questelservices/common";
import { CommonComponent } from "@questelservices/common-vue";
import { UserService } from './service/UserService';
import notify from 'devextreme/ui/notify';
import _ from "lodash";
import { UserSettingReportName, UserSettingName } from './models/UserSetting';
import UserSettingsModule from './store/UserSettingsModule'
import { UserSettingsService } from './service/UserSettingsService';
import store from './store';


const mediaService = new MediaQueryService();
const userService = new UserService();
const userSettingsService = new UserSettingsService(store);

function getScreenSizeInfo() {
  const screenSizes = mediaService.sizes;

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
  };
}

export default {
  name: "app",
  data() {
    return {
      title: "Questel Services Cost Management",
      screen: getScreenSizeInfo(),
      userFontSize: 12
    };
  },
  computed: {
    cssClasses() {
      return ["app"].concat(this.screen.cssClasses);
    },
    getFontSize() {
      return {
        '--fontSize' : this.userFontSize + 'px'
      }
    }
  },
  methods: {
    screenSizeChanged() {
      this.screen = getScreenSizeInfo();
    },
    handleUserPreferenceChangeEvent(value) {
      this.userFontSize = value;
    },
    async handleUserSettingsChanged(userSettings) {
      await userSettingsService.setUserSettings(userSettings);

    },
    async handleLoginEventBus() {
      let result = await userService.getUserSettings()
        .then(this.handleGetUserSettings)
        .catch(function(err){
          notify("Error loading user settings.", "error", 10000);
          return [];
        });

        await userSettingsService.setUserSettings(result);

    },
    async handleGetUserSettings(success) {
      var fontSize = _.find(success,function(item) {
          return item.ReportName === UserSettingReportName.UserPreference &&
                item.Name === UserSettingName.DataTableFontSize;
        });

      this.userFontSize = fontSize ? Number(fontSize.Value) : 12;

      return success;
      
    }
  },

  mounted() {
    mediaService.subscribe(this.screenSizeChanged);
    this.$root.$on("login-success", this.handleLoginEventBus);
    this.$root.$on("user-preference", this.handleUserPreferenceChangeEvent);
    this.$root.$on("user-settings-changed", this.handleUserSettingsChanged);
  },

  beforeDestroy() {
    mediaService.unsubscribe(this.screenSizeChanged);
    this.$root.$off("login-success");
    this.$root.$off("user-preference");
    this.$root.$off("remove-popover-cache");
  },

  components: {
    CommonComponent,
    TheFooter    
  }
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  @import "./themes/generated/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}

.content {
    padding: 0px 15px 15px 15px;
}
</style>

<style lang="scss">
@import './themes/generated/data-grid.style.scss';

@include table-font-size(var(--fontSize));
</style>